<div class="message-popup-wrapper invoiced-date-dialog">
  <div class="message-popup-header">
    <div class="ibc-body-text-large-bold">{{ data.title }}</div>
    <div class="card-action-icons">
      <app-svg-icon
        [iconName]="'close'"
        class="cursor"
        [isStaticSvg]="true"
        [isFrom]="'Popup'"
        (staticIconClicked)="onCancel()">
      </app-svg-icon>
    </div>
  </div>

  <div class="message-popup-content">
    <mat-form-field appearance="outline" class="mat-md custom-datepicker remove-focus invoiced-date-field">
      <mat-label>Invoiced Date</mat-label>
      <input matInput required [matDatepicker]="invoicedDatePicker" [formControl]="invoicedDate" [min]="minDate" [max]="maxDate" />
      <mat-datepicker-toggle matPrefix [for]="invoicedDatePicker">
        <mat-icon matDatepickerToggleIcon>
          <app-svg-icon [iconName]="actionIcons.datePicker" [isStaticSvg]="true"></app-svg-icon>
        </mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #invoicedDatePicker></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="popup-footer">
    <button type="button" class="ibc-medium-button ibc-secondary-default-button cursor" (click)="onCancel()">
      <span class="ibc-body-text-regular">{{ popupButtons.Cancel }}</span>
    </button>
    <button
      type="button"
      class="ibc-medium-button ibc-primary-default-button"
      [ngClass]="invoicedDate.valid ? 'cursor' : ''"
      [disabled]="invoicedDate.invalid"
      (click)="onProceed()">
      <span class="ibc-body-text-regular">{{ popupButtons.Save }}</span>
    </button>
  </div>
</div>
